import React from 'react';
import questionareStyle from '../../style';
import {Redirect} from 'react-router-dom';

export default function Slide9(props) {
	let style = questionareStyle();

	return (
		<div style={style.ageInputContainer()}>
			<p
				style={{
					...{
						marginTop: '1rem',
					},
					...style.questionareText(),
				}}
			>
				Thanks for making an account!
			</p>
			<button style={style.nextButton()} onClick={props.nextPressed}>
				Make change
			</button>
		</div>
	);
}
